// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width: 1200px) {\n.dashboard-card-wrapper[data-v-5f1ab3ce] {\n    overflow-x: scroll;\n}\n}\n[data-v-5f1ab3ce]::-webkit-scrollbar {\n  display: none;\n}\n.text-underline[data-v-5f1ab3ce] {\n  border-bottom: 3px solid var(--bs-blue);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
